import React from 'react';
import { Spin } from 'antd';
import useCurrentUser from 'hooks/useCurrentUser';
import useInsuranceBillingStatus from 'hooks/useInsuranceBillingStatus';
import { isBillingOwnerOrAdmin } from './access';
import Landing from './Landing';
import Dashboard from './Dashboard';
import s from './s.module.less';

// gate：绑定/进度以 /status 接口为准，owner 视角以 currentUser 为准（canBind 在 OPS 代登录下恒 false，见 access.ts）。
// - owner 视角（owner / 代持 owner 的 admin staff）：bound 且 onboardingCompleted → claims dashboard；否则 landing
//   （bound 但未完成 → landing 的 CTA 变为 Resume）
// - 团队 provider：canView（被加进 rendering provider 名单）→ dashboard；否则 landing（隐藏 CTA，展示 banner）
const GatedEntry = () => {
    const [currentUser, userLoading] = useCurrentUser();
    const [status, loading] = useInsuranceBillingStatus();

    if (loading || (!currentUser && userLoading)) {
        return (
            <div className={s.gateLoading}>
                <Spin />
            </div>
        );
    }

    const showDashboard = isBillingOwnerOrAdmin(currentUser)
        ? !!status?.bound && status?.onboardingCompleted === true
        : !!status?.canView;

    if (showDashboard) {
        return <Dashboard />;
    }

    return <Landing status={status} />;
};

const InsuranceBillingPage = () => {
    return <GatedEntry />;
};

export default InsuranceBillingPage;
